var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 66,
    viewBox: "0 0 60 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5027_23449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.79361 0C0.912456 0 -0.108887 1.40952 -0.108887 5.86263V19.8552C1.40478 23.884 4.41117 27.1757 8.28669 29.0474V30.3343V8.80414C8.28669 8.3956 8.47053 8.23212 8.79737 8.23212H9.30804C9.71659 8.23212 9.79827 8.39554 10.0434 8.68152L21.0536 21.2442C24.0768 24.676 24.6079 26.1263 28.2848 26.1263H31.4919C35.1687 26.1263 35.7407 24.676 38.7231 21.2442L49.6107 8.68152C49.8558 8.41597 49.958 8.23212 50.4074 8.23212H50.9181C51.204 8.23212 51.3062 8.41603 51.3062 8.80414V39.7716C54.1251 39.7716 56.9236 38.0557 59.7426 33.0919V5.86263C59.7426 1.45038 58.6599 0 54.7788 0H48.5485C45.1576 0 44.9942 1.26649 42.5634 4.28971L31.0425 18.5887C30.8178 18.8542 30.6544 19.0994 30.2458 19.0994H29.5717C29.4112 19.0817 29.2571 19.0262 29.1222 18.9374C28.9872 18.8486 28.8753 18.7291 28.7955 18.5887L17.2133 4.28971C14.7621 1.24607 14.4965 0 11.0852 0H4.79361Z",
    fill: "#4092FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4399 36.5034H39.6219",
    stroke: "#4092FF",
    strokeWidth: 4.08542,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4399 47.8813H39.6219",
    stroke: "#4092FF",
    strokeWidth: 4.08542,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.149414 23.8384V51.129C-0.149414 61.9553 4.20156 66.0408 15.6816 66.0408H43.9119C55.3919 66.0408 59.7429 61.9553 59.7429 51.129V36.6053C59.0288 38.248 57.8494 39.6456 56.3502 40.6257C54.851 41.6058 53.0976 42.1255 51.3065 42.1207V50.2915C51.3065 56.2562 49.6519 58.013 43.8506 58.013H15.9472C10.1459 58.013 8.28699 56.2767 8.28699 50.2915V31.3964C4.67231 29.9496 1.68456 27.2729 -0.149414 23.8384Z",
    fill: "#4092FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5027_23449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.687,
    height: 66,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBg);
export default __webpack_public_path__ + "static/media/iconBg.fc25c68f4f8bb6c21828b954b533868d.svg";
export { ForwardRef as ReactComponent };